export const QUERYPARAM_SHOULD_OPEN_TEST = 'shouldOpenTest';

export enum TEAM_LOGIN_VARIANT {
  TEST = 'TEST',
  LEARN = 'LEARN',
}
